// courses/course_C03.ts

export const course_C03 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 매니저가 알아야 할 기초 법률</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">매니지먼트 업무는 계약에서 시작해 계약으로 끝납니다. 법을 모르면 본인과 아티스트를 지킬 수 없습니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>대중문화예술산업발전법의 이해:</strong> 매니저가 되기 위해 필요한 법적 근거와 권리, 의무를 규정한 법입니다. 기획사가 정식으로 등록되어 있는지, 내가 하는 업무가 법의 테두리 안에 있는지 확인하는 기초가 됩니다.</li>
      <li style="margin-bottom: 8px;"><strong>표준전속계약서의 중요성:</strong> 아티스트와 회사 간의 권리와 의무를 규정한 표준 양식입니다. 수익 배분, 계약 기간, 해지 조건 등 핵심 내용을 이해해야 현장에서 발생할 수 있는 분쟁을 예방할 수 있습니다.</li>
      <li><strong>근로기준법과 현장:</strong> 매니저의 업무 특성상 불규칙한 근무 시간이 발생하지만, 휴게 시간과 휴일 등 기본적인 근로 권리에 대해 인지하고 있어야 합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 매니저의 직업 윤리</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">실무 능력보다 중요한 것이 '사람'을 대하는 태도와 윤리 의식입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>비밀 유지의 의무:</strong> 아티스트의 사생활, 건강 정보, 차기작 대본, 출연료 등 업무상 알게 된 모든 정보는 절대 외부(친구, 가족 포함)에 발설하지 않는 것이 철칙입니다.</li>
      <li style="margin-bottom: 8px;"><strong>금품 및 향응 수수 금지:</strong> 캐스팅이나 스케줄 편의를 대가로 관계자에게 금품을 요구하거나 받아서는 안 됩니다. 이는 본인뿐만 아니라 아티스트의 이미지에 치명적인 타격을 줍니다.</li>
      <li><strong>공과 사의 구별:</strong> 아티스트와 가까운 사이가 되더라도, 공적인 업무 시간과 사적인 친분을 명확히 구분하여 업무의 전문성을 유지해야 합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 성교육 및 성희롱 예방</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">엔터테인먼트 현장은 다양한 성별의 사람들이 밀폐된 공간(차량, 대기실 등)에서 밀접하게 일하는 특수성이 있습니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>성희롱 예방의 핵심:</strong> 상대방이 불쾌감을 느낄 수 있는 신체 접촉, 성적인 농담, 외모 비하 발언은 어떠한 상황에서도 용납되지 않습니다.</li>
      <li style="margin-bottom: 8px;"><strong>아티스트 보호:</strong> 아티스트가 현장에서 성희롱이나 부적절한 대우를 받지 않도록 관찰하고 보호할 의무가 있습니다. 문제 발생 시 즉시 회사에 보고하고 공식적인 절차를 밟아야 합니다.</li>
      <li><strong>디지털 성범죄 주의:</strong> 아티스트의 동의 없는 촬영이나 유포는 명백한 범죄 행위임을 명심해야 합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 왜 이 교육이 '생존 교육'인가?</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">이 기초 교육은 단순히 착한 사람이 되기 위한 교육이 아닙니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>법적 리스크 방어:</strong> 무지함으로 인해 발생할 수 있는 법적 분쟁으로부터 자신을 보호합니다.</li>
      <li style="margin-bottom: 8px;"><strong>신뢰 자산 구축:</strong> 윤리 의식이 철저한 매니저는 업계에서 "함께 일하고 싶은 사람"이라는 평판을 얻게 되며, 이는 곧 최고의 커리어 자산이 됩니다.</li>
      <li><strong>건강한 현장 문화:</strong> 매니저가 먼저 올바른 성 인지 감수성을 가질 때, 아티스트와 스태프 모두가 존중받는 현장이 만들어집니다.</li>
    </ul>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 한 줄 요약</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "법과 윤리를 지키는 것은 나를 지키는 가장 강력한 방패이며, 아티스트를 빛나게 하는 가장 깨끗한 배경이 됩니다."
    </p>
  </div>
`;
